import React, { useContext, useEffect, useState } from 'react'
import {
  CButton,
  CCol,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { raiseToast } from '../../../utils/helper'
import useAxios from 'axios-hooks'
import { RESET_USER_PASSWORD } from '../../../utils/urls'
import { AppContext } from '../../../context/app'

const ResetPasswordModal = (props) => {
  const { user, showModal, handleClose } = props
  const [password, setPassword] = useState('')
  const [passwordHide, setPasswordHide] = useState(true)
  const [cnfPassword, setCnfPassword] = useState('')
  const [cnfPasswordHide, setCnfPasswordHide] = useState(true)
  const [errorData, setErrorData] = useState({})
  const { setLoader } = useContext(AppContext)

  const handleChange = (event, func) => {
    const { value } = event.target
    func(value)
  }

  const [{ data: resetPasswordData, loading: resetPasswordLoading }, resetPasswordCall] = useAxios(
    {
      url: RESET_USER_PASSWORD,
      method: 'put',
    },
    { manual: true },
  )

  const validateInfo = () => {
    let isFormValid = true
    let temp = {}

    if (!password && password.trim().length === 0) {
      isFormValid = false
      temp.password = 'Password cannot be Empty!'
    }

    if (password !== cnfPassword) {
      isFormValid = false
      temp.cnfPassword = 'Confirm Password should be same as that of password!'
    }

    setErrorData({ ...temp })
    return isFormValid
  }
  const handleResetPassword = () => {
    if (validateInfo()) {
      resetPasswordCall({
        data: {
          user_id: user._id,
          password: password,
        },
      })
    }
  }

  useEffect(() => {
    setLoader(resetPasswordLoading)
  }, [resetPasswordLoading])

  useEffect(() => {
    if (resetPasswordData && resetPasswordData.success) {
      handleClose()
      raiseToast('success', 'Password reset successfully')
    }
  }, [resetPasswordData])

  return (
    <>
      <CModal size="lg" visible={showModal} alignment="center">
        <CModalHeader className="px-5 py-4">
          <CModalTitle>{'Reset Password'} </CModalTitle>
        </CModalHeader>
        <CModalBody className="px-5 py-4">
          <CRow className="mt-3">
            <CCol style={{ position: 'relative' }}>
              <CFormLabel>Password*</CFormLabel>
              <CFormInput
                type={passwordHide ? 'password' : 'text'}
                value={password}
                name="password"
                onChange={(e) => handleChange(e, setPassword)}
              />
              <div
                style={{
                  position: 'absolute',
                  right: '5%',
                  top: errorData.password ? '45%' : '55%',
                }}
              >
                {!passwordHide ? (
                  <FontAwesomeIcon icon={faEye} size="lg" onClick={() => setPasswordHide(true)} />
                ) : (
                  <FontAwesomeIcon
                    icon={faEyeSlash}
                    size="lg"
                    onClick={() => setPasswordHide(false)}
                  />
                )}
              </div>
              <div className="message-text error-message">
                <p>{errorData.password}</p>
              </div>
            </CCol>
          </CRow>
          <CRow className="mt-3">
            <CCol style={{ position: 'relative' }}>
              <CFormLabel>Confirm Password*</CFormLabel>
              <CFormInput
                type={cnfPasswordHide ? 'password' : 'text'}
                value={cnfPassword}
                name="password"
                onChange={(e) => handleChange(e, setCnfPassword)}
              />
              <div
                style={{
                  position: 'absolute',
                  right: '5%',
                  top: errorData.cnfPassword ? '45%' : '55%',
                }}
              >
                {!cnfPasswordHide ? (
                  <FontAwesomeIcon
                    icon={faEye}
                    size="lg"
                    onClick={() => setCnfPasswordHide(true)}
                  />
                ) : (
                  <FontAwesomeIcon
                    icon={faEyeSlash}
                    size="lg"
                    onClick={() => setCnfPasswordHide(false)}
                  />
                )}
              </div>
              <div className="message-text error-message">
                <p>{errorData.cnfPassword}</p>
              </div>
            </CCol>
          </CRow>
        </CModalBody>
        <CModalFooter>
          <CButton className="text-white" color="info" onClick={handleResetPassword}>
            Reset Password
          </CButton>
          <CButton className="text-white" color="info" onClick={handleClose}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ResetPasswordModal
